import React, {useEffect, useLayoutEffect, useState} from 'react';
import EsiaActivateCard from './esiaActivateCard';
import {LoginLayout} from '../components/layout';
import {useStyles} from '../../../shared/hooks/styles';
import {useDispatch} from 'react-redux';
import {LoginState} from '../../../shared/models/login/loginStep';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {loginSlice} from '../../../redux/reducers/login';
import {Screens} from '../../../shared/routing';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {BackHandler, Platform} from 'react-native';
import {useIsSmallScreenDevice} from '../../../shared/hooks/useIsSmallScreenDevice';

const title = 'Ваше заявление принято';
export default () => {
  const isSmallDevice = useIsSmallScreenDevice();
  const styles = useStyles(() => {
    return {
      root: {
        position: 'relative',
        paddingBottom: 0,
        overflow: 'hidden',
        margin: Platform.OS === 'ios' ? 1 : 0,
        flex: Platform.OS === 'ios' ? 0.9 : isSmallDevice ? 0 : 1,
      },
    };
  });

  const dispatch = useDispatch();
  const navigation = useNavigation();

  const onBack = () => {
    dispatch(loginSlice.actions.reset(null));
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
    navigation.navigate(Screens.Login);
  };

  React.useEffect(() => {
    const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
      onBack();
      return true;
    });
    return () => backHandler.remove();
  }, []);

  useFocusEffect(() => {
    if (Platform.OS !== 'ios') return;
    return () => {
      dispatch(loginSlice.actions.reset(null));
      dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
      navigation.navigate(Screens.Login);
    };
  });

  return (
    <LoginLayout
      title={title}
      showLogo={false}
      onBack={onBack}
      containerStyle={styles.root}
      titleStyle={{paddingBottom: 5}}>
      <EsiaActivateCard />
    </LoginLayout>
  );
};
